(function(){
  'use strict';

  /* ── CURSOR ── */
  var cursor = document.getElementById('lv-cursor');
  var ring   = document.getElementById('lv-cursor-ring');
  var mx = window.innerWidth / 2, my = window.innerHeight / 2;
  var rx = mx, ry = my;

  var isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) || window.innerWidth < 768;

  if (isMobile) {
    document.body.classList.add('mobile');
    if (cursor) cursor.style.display = 'none';
    if (ring)   ring.style.display   = 'none';
  } else {
    if (cursor) { cursor.style.left = mx + 'px'; cursor.style.top = my + 'px'; }
    if (ring)   { ring.style.left   = rx + 'px'; ring.style.top   = ry + 'px'; }

    document.addEventListener('mousemove', function(e) {
      mx = e.clientX;
      my = e.clientY;
      if (cursor) { cursor.style.left = mx + 'px'; cursor.style.top = my + 'px'; }
    });

    (function animRing() {
      rx += (mx - rx) * 0.09;
      ry += (my - ry) * 0.09;
      if (ring) { ring.style.left = rx + 'px'; ring.style.top = ry + 'px'; }
      requestAnimationFrame(animRing);
    })();

    document.querySelectorAll('a, button, .lv-card, .lv-pcell').forEach(function(el) {
      el.addEventListener('mouseenter', function() {
        if (cursor) { cursor.style.width = '14px'; cursor.style.height = '14px'; }
        if (ring)   { ring.style.width = '52px';   ring.style.height = '52px';   ring.style.borderColor = 'rgba(174,154,91,0.7)'; }
      });
      el.addEventListener('mouseleave', function() {
        if (cursor) { cursor.style.width = '8px';  cursor.style.height = '8px'; }
        if (ring)   { ring.style.width = '32px';   ring.style.height = '32px';  ring.style.borderColor = 'rgba(174,154,91,0.5)'; }
      });
    });
  }

  /* ── LOADER ── */
  var loader = document.getElementById('lv-loader');
  if (loader) {
    setTimeout(function() {
      loader.classList.add('hidden');
      initReveals();
    }, 1600);
  } else {
    initReveals();
  }

  /* ── SCROLL REVEALS ── */
  function initReveals() {
    var els = document.querySelectorAll('.lv-reveal, .lv-reveal-l, .lv-reveal-r');
    if (!els.length) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) {
      if (el.getBoundingClientRect().top < window.innerHeight - 60) {
        el.classList.add('is-visible');
      } else {
        obs.observe(el);
      }
    });
  }

  /* ── NAV SCROLL ── */
  var nav = document.querySelector('.lv-nav');
  window.addEventListener('scroll', function() {
    var s = window.scrollY;
    if (nav) nav.classList.toggle('lv-nav--solid', s > 40);
    updatePageDots();
  }, { passive: true });

  /* ── PAGE DOTS ── */
  function updatePageDots() {
    var sections = document.querySelectorAll('[data-lv-section]');
    var dots     = document.querySelectorAll('.lv-page-nav__dot');
    if (!sections.length || !dots.length) return;
    sections.forEach(function(sec, i) {
      var r = sec.getBoundingClientRect();
      if (r.top <= window.innerHeight * 0.5 && r.bottom >= window.innerHeight * 0.5) {
        dots.forEach(function(d) { d.classList.remove('is-active'); });
        if (dots[i]) dots[i].classList.add('is-active');
      }
    });
  }

  /* ── HERO PARALLAX ── */
  var hero       = document.querySelector('.lv-hero');
  var heroGeo    = document.querySelector('.lv-hero__geo');
  var heroParallax = document.querySelector('.lv-hero__parallax');
  if (hero && !isMobile) {
    hero.addEventListener('mousemove', function(e) {
      var rect = hero.getBoundingClientRect();
      var dx = (e.clientX - rect.left - rect.width  / 2) / rect.width;
      var dy = (e.clientY - rect.top  - rect.height / 2) / rect.height;
      if (heroGeo)      heroGeo.style.transform      = 'translate(' + (dx * -10) + 'px,' + (dy * -7) + 'px)';
      if (heroParallax) heroParallax.style.transform = 'translate(' + (dx *  18) + 'px,' + (dy * 12) + 'px)';
    });
    hero.addEventListener('mouseleave', function() {
      if (heroGeo)      heroGeo.style.transform      = 'translate(0,0)';
      if (heroParallax) heroParallax.style.transform = 'translate(0,0)';
    });
  }

  /* ── MOBILE MENU ── */
  var hamburger  = document.querySelector('.lv-nav__hamburger');
  var mobileMenu = document.querySelector('.lv-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      mobileMenu.classList.toggle('is-open');
      document.body.style.overflow = mobileMenu.classList.contains('is-open') ? 'hidden' : '';
    });
  }
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── PAGE DOT CLICKS ── */
  document.querySelectorAll('.lv-page-nav__dot').forEach(function(dot) {
    dot.addEventListener('click', function() {
      var target = document.querySelector('[data-lv-section="' + dot.getAttribute('data-section') + '"]');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  /* ── CARD TILT ── */
  if (!isMobile) {
    document.querySelectorAll('.lv-card').forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width  - 0.5;
        var y = (e.clientY - r.top)  / r.height - 0.5;
        card.style.transform = 'translateY(-4px) perspective(800px) rotateX(' + (-y * 4) + 'deg) rotateY(' + (x * 4) + 'deg)';
      });
      card.addEventListener('mouseenter', function() { card.style.transition = 'transform 0.15s'; });
      card.addEventListener('mouseleave', function() {
        card.style.transform  = 'translateY(0) perspective(800px) rotateX(0) rotateY(0)';
        card.style.transition = 'transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94)';
      });
    });
  }

  /* ── WA HELPER ── */
  window.lv_wa = function(treatment) {
    var base = 'https://wa.me/6282266343194?text=Hello%2C%20I%20would%20like%20to%20book%20a%20consultation';
    if (treatment) base += '%20for%20' + encodeURIComponent(treatment);
    window.open(base, '_blank', 'noopener');
  };

})();
